<template>
  <div>
    <div @click="toggle()" ref="button">
      <slot name="dropdown-button"></slot>
    </div>
    <div class="z-10" ref="content">
      <transition
        enter-active-class="transition duration-100 ease-out"
        enter-class="transform scale-75 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-class="transform scale-100 opacity-100 "
        leave-to-class="transform scale-75 opacity-0"
      >
        <div
          v-show="isOpen"
          class="w-56 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5"
        >
          <div
            class="py-1 text-left"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            <slot name="dropdown-content"></slot>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
// Implementing this b/c https://github.com/tailwindlabs/tailwindui-issues/issues/147
import { createPopper } from "@popperjs/core";

export default {
  data() {
    return {
      isOpen: false,
      popperInstance: null
    };
  },
  methods: {
    close(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
    toggle() {
      this.isOpen = !this.isOpen;
      this.popperInstance.update();
    }
  },
  mounted() {
    document.addEventListener("click", this.close);

    this.popperInstance = createPopper(
      this.$refs["button"],
      this.$refs["content"],
      {
        placement: "bottom-end",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 10]
            }
          }
        ]
      }
    );
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);

    if (this.popperInstance) {
      this.popperInstance.destroy();
      this.popperInstance = null;
    }
  }
};
</script>
